// extracted by mini-css-extract-plugin
module.exports = {"manual-reward-table":"manual-reward-table-4f975cd369675e76cda3112f05cdeaec"};